import React, { Component } from 'react';
import Demandeur from './forms/demandeur';
import Enfants from './forms/enfants';
import Conjoint from './forms/conjoint';
import Logement from './forms/logement';
import Ressources from './forms/ressources';
import Questionnaire from './forms/avant-de-terminer.js';
import RevenusImposables from './forms/declaration-revenus-imposable.js';
import Resultats from './forms/resultat.js';


class Step extends Component {

	render() {
		const hasEnfant = Object.keys(this.props.individus).length > 0;
		// routage des etapes
		switch (this.props.step) {
			case 1:
				return (
					<Demandeur validateStep={this.props.validateStep} restart={this.props.restart} />
				);
				break;
			case 2:

				return (
					<Enfants
						validateStep={this.props.validateStep}
						individus={this.props.individus}
						hasEnfant={hasEnfant}
						previousStep={this.props.previousStep}
						restart={this.props.restart} />
				);
				break;
			case 3:
				/* Individus : toute personne n'etant pas conjoint ni demandeur */

				const enCouple = this.props.famille.en_couple;
				const statutMarital = (this.props.demandeur.statut_marital === 'marie' || this.props.demandeur.statut_marital === 'pacse') ?
					this.props.demandeur.statut_marital : 'non_renseigne';
				return (
					<Conjoint validateStep={this.props.validateStep}
						hasEnfant={hasEnfant}
						enCouple={enCouple}
						statutMarital={statutMarital}
						previousStep={this.props.previousStep}
						restart={this.props.restart} />
				);
				break;
			case 4:
				// SituationLogement , Ville
				const codePostal = this.props.menage.code_postal;
				const ville = this.props.menage.depcom

				return (
					<Logement validateStep={this.props.validateStep}
						codePostal={codePostal}
						ville={ville}
						previousStep={this.props.previousStep}
						restart={this.props.restart} />
				);
				break;
			case 5:
				return (
					<Ressources validateStep={this.props.validateStep}
						individus={this.props.individus}
						conjoint={this.props.conjoint}
						famille={this.props.famille}
						previousStep={this.props.previousStep}
						restart={this.props.restart}
						updateStore={(data) => this.props.validateStep(data, true)} />
				);
				break;
			case 6:
				return (
					<Questionnaire
						validateStep={this.props.validateStep}
						previousStep={this.props.previousStep}
						restart={this.props.restart}
						reductionEligibilitySelection={this.props.menage.reductionEligibilityData?.selectedOption || null}
						menage={this.props.menage}
					/>
				)
				break;
			case 7:
				return (
					<Resultats
						validateStep={this.props.validateStep}
						individus={this.props.individus}
						conjoint={this.props.conjoint}
						demandeur={this.props.demandeur}
						famille={this.props.famille}
						foyer_fiscal={this.props.foyer_fiscal}
						menage={this.props.menage}
						restart={this.props.restart}
						definedRessources={this.props.definedRessources}
					/>
				);
				break;
			case 8:
				return (
					<RevenusImposables
						validateStep={this.props.validateStep}
						individus={this.props.individus}
						demandeur={this.props.demandeur}
						conjoint={this.props.conjoint}
						returnToResult={this.props.previousStep}
					/>
				)
				break; //revenu imposable N-2
			default:
				return (
					<div className="step">
						<h3> Step : {this.props.step} </h3>

					</div>
				); break;
		}


	}
}

export default Step;
